/** @jsxImportSource @emotion/react */

import { FC } from 'react'
import Modal from '@mui/material/Modal'
import { useQuery } from '@apollo/client'
import { FIND_SUBJECT_BY_PLATFORM } from 'queries/subject'
import { findSubjectByPlatform, findSubjectByPlatformVariables } from '__generatedTypes__/findSubjectByPlatform'
import Loader from 'components/Loader'
import { Form, Props as FormProps } from './Form'
import * as classes from './styles'

type Props = {
  isOpen: boolean
  platformId: string
  onClose: () => void
} & Pick<FormProps, 'initialValues' | 'onSubmit' | 'onDelete'>

export const TaskModal: FC<Props> = ({ isOpen, platformId, onClose, ...rest }) => {
  const { data: subjectsData, loading: loadingSubjects } = useQuery<
    findSubjectByPlatform,
    findSubjectByPlatformVariables
  >(FIND_SUBJECT_BY_PLATFORM, {
    variables: { platformId },
  })

  const subjects = subjectsData?.findSubjectByPlatform?.tabs || []

  // added disableEnforceFocus sx={{ zIndex: 100 }} to fix an issue with editor tooltips
  return (
    <Modal open={isOpen} onClose={onClose} disableEnforceFocus sx={{ zIndex: 100 }}>
      <div css={classes.modalContainer}>
        {loadingSubjects ? <Loader /> : <Form {...rest} subjects={subjects} onCancelClick={onClose} />}
      </div>
    </Modal>
  )
}
